import { Popover } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconQuestionMark } from "@tabler/icons-react";
import type { ReactNode } from "react";

interface InfoTooltipProps {
  content: ReactNode;
  /** `sm` for inline use next to small labels (14 px button instead of 20 px). */
  size?: "md" | "sm";
}

const InfoTooltip = ({ content, size = "md" }: InfoTooltipProps) => {
  const [opened, { close, open }] = useDisclosure(false);

  return (
    <Popover
      width={320}
      position="bottom-start"
      withArrow
      shadow="md"
      opened={opened}
    >
      <Popover.Target>
        <button
          type="button"
          className={`flex items-center justify-center rounded-full border border-gray-900 bg-black/10 text-gray-900 transition-colors hover:bg-black/20 ${
            size === "sm" ? "h-3.5 w-3.5" : "h-5 w-5"
          }`}
          onMouseEnter={open}
          onMouseLeave={close}
          onClick={open}
        >
          <IconQuestionMark size={size === "sm" ? 9 : 12} stroke={2.5} />
        </button>
      </Popover.Target>
      <Popover.Dropdown className="pointer-events-none">
        <div className="flex flex-col gap-2 text-sm text-gray-700">
          {content}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};

export default InfoTooltip;
